import { gql } from '@apollo/client';

export const STUDENT_LOG_BOOK = gql`
  query studentLogBook($where: StudentLogBookWhereInput!) {
    studentLogBook(where: $where) {
      year
      month
      batchSubjectConfigurationId
      subjectCode
      subjectName
      lecturer
      student {
        id
        name
        regNumber
        sliitID
        waiID
        class_name
        assessment {
          id
          title
          result
          allocatedMarks
          endDate
        }
        attendance {
          date
          attendance
          endDate
          isExtra
        }
      }
    }
  }
`;

export const RESULT_SHEET_REPORT = gql`
  query resultSheetReport($where: ResultSheetReportWhereInput!) {
    resultSheetReport(where: $where) {
      batchSubjectConfigurationId
      subjectCode
      subjectName
      student {
        id
        regNumber
        name
        grade
        status
        waiID
        sliitID
        attendancePercentage
      }
    }
  }
`;
